import { createContext, useContext } from 'react'
import type { ServerAPI } from 'server/serverAPI'

export const ServerConnection = createContext(null)

export function useServerConnection(): ServerAPI {
    return useContext(ServerConnection)
}
